import React from 'react';
import {Card, CardActions, CardContent, CardMedia, Button, Typography} from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import moment from 'moment';
import {useDispatch} from 'react-redux';
import {getDiabetesPosts, deleteDiabetesPost} from '../../../actions/diabetesposts';
import {Grid} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CardHeader from '@material-ui/core/CardHeader';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 345
  },
  media: {
    height: 0,
    paddingTop: '56.25%', // 16:9
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  avatar: {
    backgroundColor: 'purple',
  },
}));



const DiabetesPost = ({post, setCurrentId, pageNumber}) =>{
  const classes = useStyles();
  const dispatch = useDispatch();
  const user = JSON.parse(localStorage.getItem('profile'));
  const [expanded, setExpanded] = React.useState(false);

  
  return (
    <Card className={classes.root}>
      <CardHeader
        avatar={
          <Avatar aria-label="recipe" className={classes.avatar} >
          {post.name[0]}{post.name.split(" ")[1][0]}
          </Avatar> 
        }
        action={
          <IconButton aria-label="settings">
            {(user?.result?.googleId === post?.creator || user?.result?._id === post?.creator) && (
            <div  className = {classes.overlay2}>
                <Button style = {{color : 'black'}}  size = "small" onClick = {()=> setCurrentId(post._id)}>
                    <MoreHorizIcon  fontSize = "default" />    
                </Button>
            </div>
            )}
          </IconButton>
        }
        title ={post.prediction}
        subheader= {moment(post.createdAt).fromNow()}
        >  
      </CardHeader>
      <CardMedia
        className={classes.media}
        image={post.prediction === "High Chance"? "https://www.nps.org.au/assets/_1080x596_crop_center-center_80_none/1777bb8615357c3f-e7b59352cd31-pancreas-shutterstock_496717501.jpg": "https://www.niddk.nih.gov/-/media/Images/Health-Information/Diabetes/landing/diabetes.png"}
        title={post.prediction}
      />
      <CardContent>
        <Typography variant="body2" color="textPrimary" component="p">
          Age: {post.age}    
        </Typography>
        <Typography variant="body2" color="textPrimary" component="p">
          Gender: {post.sex === "1" ? "Male" : "Female" }
        </Typography>
        <Typography variant="body2" color="textPrimary" component="p">
          Polyuria: {post.polyuria === "1" ? "Present" : "Absent" }
        </Typography>
        <Typography variant="body2" color="textPrimary" component="p">
          Polydipsia: {post.polydipsia === "1" ? "Present" : "Absent" }
        </Typography>
        <Typography variant="body2" color="textPrimary" component="p">
          Weight Loss: {post.weightloss === "1" ? "Present" : "Absent" }
        </Typography>
        <Typography variant="body2" color="textPrimary" component="p">
          Healing : {post.healing === "1" ? "Delayed" : "Normal" }
        </Typography>
        <Typography variant="body2" color="textPrimary" component="p">
          Itching: {post.itching === "1" ? "Normal" : "Abnormal" }
        </Typography>
        <Typography variant="body2" color="textPrimary" component="p">
          Irritability: {post.irritability === "1" ? "Present" : "Absent" }
        </Typography> 
        <Typography variant="body2" color="textPrimary" component="p">
          Alopecia: {post.alopecia === "1" ? "Present" : "Absent" }
        </Typography>
        <Typography variant="body2" color="textPrimary" component="p">
          Possibility: {post.probability}
        </Typography>
      </CardContent>
      <CardActions disableSpacing>
        {(user?.result?.googleId === post?.creator || user?.result?._id === post?.creator) && (
        <div>
          <Grid
            item
            container
            direction="row"
            justify="flex-end"
          >
            <Button size="small" color="secondary" onClick={() => {
              dispatch(deleteDiabetesPost(post._id))
              dispatch(getDiabetesPosts(pageNumber))
              dispatch(getDiabetesPosts(pageNumber))}}>
              <DeleteIcon fontSize="small" /> 
              Delete
            </Button>
          </Grid>
        </div>
        )} 
      </CardActions>
    </Card>
  );
};

export default DiabetesPost;

